// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AuthenticateData,
  AuthenticateErrors,
  AuthenticateResponses,
  AuthorizeOAuth2Data,
  AuthorizeOAuth2Errors,
  AuthorizeOAuth2Responses,
  BeffeAnonymousDirectTestingOnlyData,
  BeffeAnonymousDirectTestingOnlyErrors,
  BeffeAnonymousDirectTestingOnlyResponses,
  BeffeAnonymousTestingOnlyData,
  BeffeAnonymousTestingOnlyErrors,
  BeffeAnonymousTestingOnlyResponses,
  BeffeHMacDirectTestingOnlyData,
  BeffeHMacDirectTestingOnlyErrors,
  BeffeHMacDirectTestingOnlyResponses,
  ConsentOAuth2ClientData,
  ConsentOAuth2ClientErrors,
  ConsentOAuth2ClientResponses,
  GetAllFeatureFlagsData,
  GetAllFeatureFlagsErrors,
  GetAllFeatureFlagsResponses,
  GetErrorData,
  GetErrorResponses,
  GetFeatureFlagForCallerData,
  GetFeatureFlagForCallerErrors,
  GetFeatureFlagForCallerResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  LogoutData,
  LogoutErrors,
  LogoutResponses,
  RecordCrashData,
  RecordCrashErrors,
  RecordCrashResponses,
  RecordMeasureData,
  RecordMeasureErrors,
  RecordMeasureResponses,
  RecordPageViewData,
  RecordPageViewErrors,
  RecordPageViewResponses,
  RecordTraceData,
  RecordTraceErrors,
  RecordTraceResponses,
  RecordUseData,
  RecordUseErrors,
  RecordUseResponses,
  RefreshTokenData,
  RefreshTokenErrors,
  RefreshTokenResponses
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Authenticates the user with the specified provider, using either an auth code or a username and password.
 *
 * (request type: AuthenticateRequest)
 */
export const authenticate = <ThrowOnError extends boolean = false>(options?: Options<AuthenticateData, ThrowOnError>) => (options?.client ?? client).post<AuthenticateResponses, AuthenticateErrors, ThrowOnError>({
    url: '/api/auth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Removes the current user's authenticated session (if any)
 *
 * (request type: LogoutRequest)
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    url: '/api/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Refreshes the current user's authentication session (if possible)
 *
 * (request type: RefreshTokenRequest)
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshTokenData, ThrowOnError>) => (options?.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({
    url: '/api/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists all the available feature flags
 *
 * (request type: GetAllFeatureFlagsRequest)
 */
export const getAllFeatureFlags = <ThrowOnError extends boolean = false>(options?: Options<GetAllFeatureFlagsData, ThrowOnError>) => (options?.client ?? client).get<GetAllFeatureFlagsResponses, GetAllFeatureFlagsErrors, ThrowOnError>({ url: '/api/flags', ...options });

/**
 * Fetches the named feature flag for the current authenticated user
 *
 * (request type: GetFeatureFlagForCallerRequest)
 */
export const getFeatureFlagForCaller = <ThrowOnError extends boolean = false>(options: Options<GetFeatureFlagForCallerData, ThrowOnError>) => (options.client ?? client).get<GetFeatureFlagForCallerResponses, GetFeatureFlagForCallerErrors, ThrowOnError>({ url: '/api/flags/{Name}', ...options });

/**
 * Displays the health of the API
 *
 * (request type: HealthCheckRequest)
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({ url: '/api/health', ...options });

export const getError = <ThrowOnError extends boolean = false>(options?: Options<GetErrorData, ThrowOnError>) => (options?.client ?? client).get<GetErrorResponses, unknown, ThrowOnError>({ url: '/error', ...options });

/**
 * Authorizes the user to access the application in Open ID Connect.
 *
 * (request type: AuthorizeOAuth2Request)
 */
export const authorizeOAuth2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeOAuth2Data, ThrowOnError>) => (options?.client ?? client).post<AuthorizeOAuth2Responses, AuthorizeOAuth2Errors, ThrowOnError>({
    url: '/api/oauth2/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Consent for the user to authorize the OAuth2/Open ID Connect client to access their data
 *
 * (request type: ConsentOAuth2ClientRequest)
 */
export const consentOAuth2Client = <ThrowOnError extends boolean = false>(options: Options<ConsentOAuth2ClientData, ThrowOnError>) => (options.client ?? client).post<ConsentOAuth2ClientResponses, ConsentOAuth2ClientErrors, ThrowOnError>({
    url: '/api/oauth2/clients/{Id}/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Records a crash event of the product
 *
 * (request type: RecordCrashRequest)
 */
export const recordCrash = <ThrowOnError extends boolean = false>(options?: Options<RecordCrashData, ThrowOnError>) => (options?.client ?? client).post<RecordCrashResponses, RecordCrashErrors, ThrowOnError>({
    url: '/api/record/crash',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Measures an event in the product
 *
 * (request type: RecordMeasureRequest)
 */
export const recordMeasure = <ThrowOnError extends boolean = false>(options?: Options<RecordMeasureData, ThrowOnError>) => (options?.client ?? client).post<RecordMeasureResponses, RecordMeasureErrors, ThrowOnError>({
    url: '/api/record/measure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Records a page view event in the product
 *
 * (request type: RecordPageViewRequest)
 */
export const recordPageView = <ThrowOnError extends boolean = false>(options?: Options<RecordPageViewData, ThrowOnError>) => (options?.client ?? client).post<RecordPageViewResponses, RecordPageViewErrors, ThrowOnError>({
    url: '/api/record/page_view',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Records a trace event in the product
 *
 * (request type: RecordTraceRequest)
 */
export const recordTrace = <ThrowOnError extends boolean = false>(options?: Options<RecordTraceData, ThrowOnError>) => (options?.client ?? client).post<RecordTraceResponses, RecordTraceErrors, ThrowOnError>({
    url: '/api/record/trace',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Records a usage of the product
 *
 * (request type: RecordUseRequest)
 */
export const recordUse = <ThrowOnError extends boolean = false>(options?: Options<RecordUseData, ThrowOnError>) => (options?.client ?? client).post<RecordUseResponses, RecordUseErrors, ThrowOnError>({
    url: '/api/record/use',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * An example of a request that uses NO authentication for a BEFFE endpoint, which can be called directly from another client (and not from the browser, which includes CSRF protection).
 *
 * (request type: BeffeAnonymousDirectTestingOnlyRequest)
 */
export const beffeAnonymousDirectTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<BeffeAnonymousDirectTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<BeffeAnonymousDirectTestingOnlyResponses, BeffeAnonymousDirectTestingOnlyErrors, ThrowOnError>({
    url: '/api/testingonly/direct/anonymous',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * An example of a request that uses NO authentication for a BEFFE endpoint
 *
 * (request type: BeffeAnonymousTestingOnlyRequest)
 */
export const beffeAnonymousTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<BeffeAnonymousTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<BeffeAnonymousTestingOnlyResponses, BeffeAnonymousTestingOnlyErrors, ThrowOnError>({
    url: '/api/testingonly/anonymous',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * An example of a request that uses HMAC authentication for a BEFFE endpoint, which can be called directly from another client (and not from the browser, which includes CSRF protection).
 *
 * (request type: BeffeHMacDirectTestingOnlyRequest)
 */
export const beffeHMacDirectTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<BeffeHMacDirectTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<BeffeHMacDirectTestingOnlyResponses, BeffeHMacDirectTestingOnlyErrors, ThrowOnError>({
    url: '/api/testingonly/direct/hmac',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
